import styled from 'styled-components';
import { LanguageSwitcher } from './LanguageSwitcher';

const Nav = styled.nav`
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 16px;
  background: #fff;
  border-bottom: 1px solid #e6e5ec;
  box-sizing: border-box;
  flex-shrink: 0;
`;

export const Navbar = () => (
  <Nav>
    <LanguageSwitcher variant="light" />
  </Nav>
);
